export default __webpack_public_path__ + "static/media/ping.6f864733.mp3";